var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// "Datum založení" / "Datum poslední aktualizace" Od–Do filters shared by the title, product and
// product number lists. Values are calendar days in API format (YYYY-MM-DD) and are sent to the
// backend as is; the backend applies them inclusively by whole days in Europe/Prague.
import moment from "moment";
import { API_DATE_FORMAT } from "./dateUtils";
/** The backend query params (and URL params) of the date range filters. */
export var DATE_RANGE_FILTER_PARAMS = [
    "dateCreatedFrom",
    "dateCreatedTo",
    "dateUpdatedFrom",
    "dateUpdatedTo",
];
export var DATE_RANGE_FIELDS = [
    "dateCreated",
    "dateUpdated",
];
export var EMPTY_DATE_RANGE_FILTERS = {
    dateCreatedFrom: "",
    dateCreatedTo: "",
    dateUpdatedFrom: "",
    dateUpdatedTo: "",
};
/** True for a real calendar day in API format (YYYY-MM-DD). */
export var isApiDate = function (value) {
    return /^\d{4}-\d{2}-\d{2}$/.test(value) &&
        moment(value, API_DATE_FORMAT, true).isValid();
};
/** Reads the date range filters from URL params; a malformed date is ignored (treated as unset). */
export var dateRangeFiltersFromParams = function (params) {
    return DATE_RANGE_FILTER_PARAMS.reduce(function (filters, key) {
        var _a;
        var _b;
        var value = (_b = params.get(key)) !== null && _b !== void 0 ? _b : "";
        return __assign(__assign({}, filters), (_a = {}, _a[key] = isApiDate(value) ? value : "", _a));
    }, __assign({}, EMPTY_DATE_RANGE_FILTERS));
};
/** Writes the set date bounds to URL params; unset bounds are omitted to keep the URL clean. */
export var appendDateRangeParams = function (params, filters) {
    DATE_RANGE_FILTER_PARAMS.forEach(function (key) {
        if (filters[key])
            params.set(key, filters[key]);
    });
};
/** True when any date bound is set. */
export var hasActiveDateRangeFilter = function (filters) {
    return DATE_RANGE_FILTER_PARAMS.some(function (key) { return !!filters[key]; });
};
/** Per date, whether its Od is after its Do (an empty result set the user did not mean). */
export var invalidDateRanges = function (filters) {
    var isInvalid = function (from, to) { return !!from && !!to && from > to; };
    return {
        dateCreated: isInvalid(filters.dateCreatedFrom, filters.dateCreatedTo),
        dateUpdated: isInvalid(filters.dateUpdatedFrom, filters.dateUpdatedTo),
    };
};
/** True when no date range has Od after Do. */
export var areDateRangesValid = function (filters) {
    return !Object.values(invalidDateRanges(filters)).some(Boolean);
};
/**
 * The set date bounds as search criteria (unset bounds omitted). An inverted Od–Do pair — which
 * can only arrive through a bookmarked or hand-edited URL, the pane refuses to apply one — is
 * dropped as a whole: the pane keeps showing its error, but no nonsense range is sent.
 */
export var dateRangeCriteria = function (filters) {
    var invalid = invalidDateRanges(__assign(__assign({}, EMPTY_DATE_RANGE_FILTERS), filters));
    return DATE_RANGE_FIELDS.reduce(function (criteria, field) {
        if (invalid[field])
            return criteria;
        var next = __assign({}, criteria);
        ["".concat(field, "From"), "".concat(field, "To")].forEach(function (key) {
            var value = filters[key];
            if (value)
                next[key] = value;
        });
        return next;
    }, {});
};
/** Picks the date range filter values out of a list's filter object. */
export var pickDateRangeFilters = function (filters) {
    return DATE_RANGE_FILTER_PARAMS.reduce(function (picked, key) {
        var _a;
        var _b;
        return (__assign(__assign({}, picked), (_a = {}, _a[key] = (_b = filters[key]) !== null && _b !== void 0 ? _b : "", _a)));
    }, __assign({}, EMPTY_DATE_RANGE_FILTERS));
};
